import React, { Component } from 'react';
import './App.css';
import Api from './api';
import LoadingPage from './LoadingPage';
import QuizContainer from './QuizContainer';
import axios from 'axios';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    withRouter
} from "react-router-dom";
import AppContextProvider from './AppContext';
import QuizNotFound from './QuizNotFound';

class _QuizContainerLoader extends Component {
    constructor(props) {
        super(props);

        this.state = {
            backendApiUrl: null,
            loadedQuizName: null,
            isLoadingQuizData: false,
            hasQuizError: false,
            quizErrorMessage: undefined,
            quizData: null
        }
    }

    async componentDidMount() {
        const backendApiUrl = (await axios.get('/config.json')).data.backendApiUrl;
        this.setState({ backendApiUrl });
        setTimeout(() => this.refreshQuizDataIfApplicable(), 200);
    }

    async refreshQuizDataIfApplicable() {
        if (this.state.hasQuizError) {
            console.log('refreshQuizDataIfApplicable this.state.hasQuizError, this.state.quizErrorMessage', this.state.hasQuizError, this.state.quizErrorMessage);
            return;
        }

        console.log('refreshQuizDataIfApplicable this.state.backendApiUrl, this.state.isLoadingQuizData', this.state.backendApiUrl, this.state.isLoadingQuizData);

        if(!this.state.backendApiUrl || this.state.isLoadingQuizData) {
            return;
        }

        const quizName = this.props.match.params.quizName;

        console.log('refreshQuizDataIfApplicable quizName, this.state.loadedQuizName', quizName, this.state.loadedQuizName);

        try {
            if(quizName !== this.state.loadedQuizName) {
                this.setState({isLoadingQuizData: true});
                const quizData = (await axios.get(`${this.state.backendApiUrl}/${quizName}`)).data;
                this.setState({isLoadingQuizData: false, quizData, loadedQuizName: quizName});
            }
        } catch (e) {
            this.setState({isLoadingQuizData: false, hasQuizError: true, quizErrorMessage: e.statusText });
        }
    }

    componentDidUpdate() {
        this.refreshQuizDataIfApplicable();
    }

    render() {
        if (this.state.hasQuizError) {
            return <QuizNotFound message={this.state.quizErrorMessage} />
        }

        if(!this.state.backendApiUrl || this.state.isLoadingQuizData || !this.state.quizData) {
            return <LoadingPage />
        }

        return <QuizContainer quiz={this.state.quizData} backendApiUrl={this.state.backendApiUrl} />
    }
};

const QuizContainerLoader = withRouter(_QuizContainerLoader);

class App extends Component {
    render() {
        return (
            <div className="app-container">
                <Router>
                    <Switch>
                        <Route path={`/:quizName`}>
                            <AppContextProvider>
                                <QuizContainerLoader setQuizLoadingState={this.setQuizLoadingState} />
                            </AppContextProvider>
                        </Route>
                        <Route path="/">
                            <QuizNotFound />
                        </Route>
                    </Switch>
                </Router>
            </div>
        )
    }
}

export default App;